import { Module, VuexModule, Action } from 'vuex-module-decorators';
import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';
import type { ExtAxiosConfig } from '@/middleware/axios-ui';

import { BASE_URL, FETCH_RESETPASS_LOG, M_POST } from '@/utils/api';

@Module({ name: 'resetpasswordlog' })
export default class ResetPasswordLog extends VuexModule {
  @Action({ rawError: true })
  async FetchResetLog(payload: any) {
    try {
      const { criteria, __successToast } = payload || {};

      const { data } = await axios({
        url: BASE_URL + FETCH_RESETPASS_LOG,
        data: criteria,
        method: M_POST,
        __successToast
      } as ExtAxiosConfig);

      assertOk(data, 'Fetch reset password log failed');
      return data?.data;
    } catch (err: any) {
      throw toError(err, 'Fetch reset password log failed');
    }
  }
}
